<footer
  class="bg-gradient-to-r from-primary-200 via-primary-300 to-primary-400"
>
  <div
    class="lg:px-12 lg:pb-24 lg:pt-24 max-lg:px-[0.8125rem] max-lg:py-10 grid lg:grid-cols-4 mm-md-lg:grid-cols-2 gap-5 border border-primary-100"
  >
    <div class="relative text-white">
      <a
        routerLink="/"
        ngText="h2.sm"
        class="text-inherit font-semibold hover:text-inherit block w-fit mb-2"
        >JOET</a
      >
      <p ngText="p.md" class="font-normal mb-6">
        Get rewarded for being onboard, JOET it now to your destination.
      </p>
      <p
        ngText="p.md"
        class="tracking-[5px] font-medium uppercase text-inherit lg:mb-3 max-lg:mb-2"
      >
        Follow Us
      </p>
      <div class="flex gap-2">
        @for (link of socialLinks; track $index) {
          <a [href]="link.url" target="_blank" rel="noopener">
            <button
              [ngText]="'p.xl'"
              nz-button
              nzType="primary"
              nzShape="circle"
              class="size-9 rounded-lg grid place-items-center"
            >
              <ng-icon [name]="link.icon" class="text-white" />
            </button>
          </a>
        }
      </div>

      @if (appStoreUrl || googlePlayUrl) {
        <p
          ngText="p.md"
          class="tracking-[5px] font-medium uppercase text-inherit lg:mt-6 max-lg:mt-4 lg:mb-3 max-lg:mb-2"
        >
          Download the App
        </p>
        <div class="flex flex-wrap gap-2">
          @if (appStoreUrl) {
            <a
              [href]="appStoreUrl"
              target="_blank"
              rel="noopener"
              class="flex items-center gap-2 rounded-lg bg-black !text-white px-3 py-2 hover:opacity-80 transition-opacity"
              aria-label="Download JOET on the App Store"
            >
              <ng-icon name="ionLogoApple" class="text-2xl" />
              <span class="flex flex-col leading-tight">
                <span class="text-[10px]">Download on the</span>
                <span class="text-sm font-semibold">App Store</span>
              </span>
            </a>
          }
          @if (googlePlayUrl) {
            <a
              [href]="googlePlayUrl"
              target="_blank"
              rel="noopener"
              class="flex items-center gap-2 rounded-lg bg-black !text-white px-3 py-2 hover:opacity-80 transition-opacity"
              aria-label="Get JOET on Google Play"
            >
              <ng-icon name="ionLogoGooglePlaystore" class="text-2xl" />
              <span class="flex flex-col leading-tight">
                <span class="text-[10px] uppercase">Get it on</span>
                <span class="text-sm font-semibold">Google Play</span>
              </span>
            </a>
          }
        </div>
      }
    </div>
    <div class="max-lg:hidden"></div>
    <div class="relative text-white">
      <p
        ngText="p.xl"
        class="tracking-[5px] font-medium uppercase text-inherit lg:mb-4 max-lg:mb-2"
      >
        Useful Links
      </p>
      <app-navbar
        [uiClass]="'flex-col justify-start items-start gap-2'"
        [linkClass]="'font-normal'"
        linkTextKey="p.md"
      ></app-navbar>
    </div>
    <div class="relative text-white">
      <p
        ngText="p.xl"
        class="tracking-[5px] font-medium uppercase text-inherit lg:mb-4 max-lg:mb-2"
      >
        Contact Us
      </p>
      <ul class="flex flex-col justify-start items-start gap-2">
        @for (link of contactLinks; track $index) {
          <li>
            <a
              [href]="link.url"
              ngText="p.md"
              class="transition-all duration-300 group !text-white hover:opacity-70 font-normal flex items-center gap-2"
            >
              <ng-icon [name]="link.icon" class="text-inherit" />
              <span>{{ link.text }}</span>
            </a>
          </li>
        }
      </ul>
      <p
        ngText="p.md"
        class="tracking-[5px] font-medium uppercase text-inherit lg:mb-4 max-lg:mb-2 lg:mt-8 max-lg:mt-5"
      >
        Newsletter
      </p>
      <app-newsletter></app-newsletter>
    </div>
  </div>
  <div class="lg:px-12 max-lg:px-[0.8125rem] lg:py-6 max-lg:py-4">
    <p ngText="p.md" class="text-white max-lg:text-center">
      Copyright &copy; JOET Technologies LLC
    </p>
  </div>
</footer>
